import Checkbox from "@mui/material/Checkbox";
import IInputProps from "./IInputProps";
import InputContainer from "./InputContainer";
import inputWithSearchStyles from "./InputWithSearch.module.css";
import { PipedriveCompanyInputSlim } from "./PipedriveCompanyInput";
import { StringInputSlim } from "./StringInput";

export default <T,>({ name, label, formik, isIndividualName, showNewLabel }: IPipedriveOrIndividualInputProps<T>) => {
    return (
        <InputContainer name={name} label={label} formik={formik}>
            <div className={inputWithSearchStyles.container}>
                {!formik.values[isIndividualName] ? (
                    <PipedriveCompanyInputSlim name={name} formik={formik} showNewLabel={showNewLabel} />
                ) : (
                    <StringInputSlim name={name} formik={formik} />
                )}
                <label className={inputWithSearchStyles.individualCheckbox}>
                    <Checkbox size="small" checked={(formik.values[isIndividualName] as boolean) || false} onChange={e => formik.setFieldValue(isIndividualName as string, e.target.checked)} /> Individual
                </label>
            </div>
        </InputContainer>
    );
};

interface IPipedriveOrIndividualInputProps<T> extends IInputProps<T, string> {
    isIndividualName: keyof T;
    showNewLabel?: boolean;
}